import React from 'react';

const ZoomOut = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" {...props}>
      <path
        d="M12.9951 4.27295H11.3584C10.9243 4.27295 10.508 4.10051 10.2011 3.79357C9.89412 3.48662 9.72168 3.07032 9.72168 2.63623V0.999512"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.999023 4.27197L2.63574 4.27197C3.06983 4.27197 3.48613 4.09953 3.79308 3.79259C4.10002 3.48564 4.27246 3.06934 4.27246 2.63525L4.27246 0.998535"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9971 9.72607H11.3604C10.9263 9.72607 10.51 9.89851 10.203 10.2055C9.89607 10.5124 9.72363 10.9287 9.72363 11.3628V12.9995"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.998047 9.72754H2.63477C3.06885 9.72754 3.48516 9.89998 3.7921 10.2069C4.09904 10.5139 4.27148 10.9302 4.27148 11.3643L4.27148 13.001"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ZoomOut;
